import createAxiosInstance from './axiosConfig';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/arquivoController');

export default class ArquivoService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async listarTiposArquivos(processamento: any) {
    return await this.axios.get(`/listarTiposArquivos?processamento=${processamento}`);
  };

  async listarArquivosLote(tipoArq: string) {
    return await this.axios.get(`/listarArquivosLote?tipoArquivo=${tipoArq}`);
  };

  async downloadModeloLote(tipoArquivoProcessamento: string) {
    return await this.axios.get(`/downloadModeloLote?tipoArquivo=${tipoArquivoProcessamento}`, {
      responseType: 'blob',
    });
  };

  async downloadArquivoLote(caminhoArquivo: string) {
    return await this.axios.get(`/downloadArquivoLote?caminhoArquivo=${caminhoArquivo}`, {
      responseType: 'blob',
    });
  };

  async listarArquivoLoteDetalhe(idArquivo: string) {
    return await this.axios.get(`/listarArquivoLoteDetalhe?idArquivo=${idArquivo}&tipoArquivo=BAIXA_LOTE`);
  };

  async listarOrigemGenerica(tipoOrigem: string) {
    return await this.axios.get(`/listarOrigemGenerica?tipoOrigem=${tipoOrigem}`);
  };

  async downloadArquivoCadastroOrgaos() {
    return await this.axios.get(`/downloadArquivoCadastroOrgaos`, {
      responseType: 'blob',
    });
  };

  async listarArquivosLogs() {
    return await this.axios.get(`/listarArquivosLogs`);
  };

  async downloadArquivoLogs(nomeArquivo: string) {
    return await this.axios.get(`/downloadArquivoLogs?nomeArquivo=${nomeArquivo}`, {
      responseType: 'blob',
    });
  };

  async listarTiposOrigem() {
    return await this.axios.get(`/listarTiposOrigem`);
  }
  
}